export const EVENT = {
  ERROR: 'error',

  TTFB: 'core.ttfb',
  LOAD_START: 'core.loadstart',
  LOAD_RESPONSE_HEADERS: 'core.loadresponseheaders',
  LOAD_COMPLETE: 'core.loadcomplete',
  LOAD_RETRY: 'core.loadretry',
  SOURCEBUFFER_CREATED: 'core.sourcebuffercreated',
  ANALYZE_DURATION_EXCEEDED: 'core.analyzedurationexceeded',
  REMOVE_BUFFER: 'core.removebuffer',
  BUFFEREOS: 'core.buffereos',
  KEYFRAME: 'core.keyframe',
  METADATA_PARSED: 'core.metadataparsed',
  SEI: 'core.sei',
  SEI_IN_TIME: 'core.seiintime',
  FLV_SCRIPT_DATA: 'core.flvscriptdata',
  LOWDECODE: 'core.lowdecode',
  SWITCH_URL_SUCCESS: 'core.switchurlsuccess',
  SWITCH_URL_FAILED: 'core.switchurlfailed',
  SPEED: 'core.speed',
  HLS_MANIFEST_LOADED: 'core.hlsmanifestloaded',
  HLS_LEVEL_LOADED: 'core.hlslevelloaded',
  DEMUXED_TRACK:'core.demuxedtrack',

  STREAM_EXCEPTION: 'core.streamexception',
  LARGE_AV_FIRST_FRAME_GAP_DETECT: 'LARGE_AV_FIRST_FRAME_GAP_DETECT',
  LARGE_VIDEO_DTS_GAP_DETECT: 'LARGE_VIDEO_DTS_GAP_DETECT',
  LARGE_AUDIO_DTS_GAP_DETECT: 'LARGE_AUDIO_DTS_GAP_DETECT',
  AUDIO_GAP_DETECT: 'AUDIO_GAP_DETECT',
  AUDIO_OVERLAP_DETECT: 'AUDIO_OVERLAP_DETECT',
  MAX_DTS_DELTA_WITH_NEXT_SEGMENT_DETECT: 'MAX_DTS_DELTA_WITH_NEXT_SEGMENT_DETECT',
  REAL_TIME_SPEED: 'real_time_speed'
}
